<template>
  <v-card light>
    <v-img
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.2)"
      class="bg-sub white--text py-40-px"
    >
      <!-- <v-img src="/images/logo.png" contain height="40" /> -->
      <v-toolbar class="bg-transparent w-100-pct" absolute flat>
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-img>

    <v-card-text class="white pb-6-px pt-16-px">
      <v-form @keyup.native.enter="submit()">
        <v-text-field
          v-model="payload.loginname"
          class=""
          :placeholder="$t('ACCOUNT')"
          hide-details
          outlined
          required
          autofocus
        ></v-text-field>
        <v-text-field
          v-model="payload.pwd"
          class="mt-10-px"
          :placeholder="$t('PASSWORD')"
          hide-details
          outlined
          required
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
        <v-checkbox
          v-model="rememberMe"
          :label="$t('REMEMBERME')"
          color="orange"
          hide-details
          dense
          class="mt-0 mb-10-px"
        ></v-checkbox>
        <p v-if="qrPng && isPng" class="fz-16-px text-center mb-0" style="">第一次設定請掃 OTP 驗證碼加入</p>
        <v-img v-if="qrPng && isPng" :src="qrPng" class="mx-auto" contain max-width="200" max-height="200" />
        <v-alert v-if="alertMsg" class="mt-8-px" dense text type="error">
          {{ $t(alertMsg) }}
        </v-alert>
        <v-btn block dark large class="bg-main" @click="submit()">Login</v-btn>
        <!-- <v-btn block dark large class="bg-main mt-8-px" @click="otpfn()">驗證碼登入</v-btn> -->
        <!-- <v-btn block dark large class="bg-main mt-8-px" target="_blank"
        href="https://www.notion.so/PA-Developer-299aa2cbe5cd80168e96dd8e28f72804">驗證碼登入步驟說明</v-btn> -->
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'Login',

  data() {
    return {
      showPassword: false,
      rememberMe: false,
      alertMsg: '',
      payload: {
        loginname: '',
        pwd: ''
      },
      qrPng: null,
      isPng: false
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    ...mapMutations('common', ['ChangeDialog']),
    ...mapActions('auth', ['setAuth']),
    ...mapActions('message', ['setSnackbar']),
    init() {
      const rememberData = localStorage.getItem('rememberData')
      if (rememberData) {
        this.payload = JSON.parse(rememberData)
        this.rememberMe = true
      }
    },
    async submit() {
      this.alertMsg = ''
      for (const i in this.payload) {
        const curr = this.payload[i]
        if (!curr) {
          this.alertMsg = 'LOGINERROR_1'
          return
        }
      }
      this.setAuth({ token: '', isLogin: false })
      if (this.rememberMe) {
        const reData = JSON.stringify(this.payload)
        localStorage.setItem('rememberData', reData)
      }
      this.$api.auth
        .login(this.payload, { responseType: 'blob' })
        .then((res) => {
          // console.log(res)
          const mimeType = res.type
          if (mimeType === 'image/png') {
            // PNG 圖片
            this.isPng = true
            this.jsonData = null
            this.qrPng = URL.createObjectURL(res)
            // console.log(this.qrPng)
          }
          if (res.token) {
            const token = res.token
            delete res.token
            const loginUser = res
            loginUser.roles = loginUser.roles.split(',')
            const data = {
              loginUser: loginUser,
              isLogin: true,
              token: token
            }
            this.setAuth(data)
            const redirect = this.$router.currentRoute.query.redirect
            if (redirect) {
              this.$router.push(redirect)
            }
            this.ChangeDialog('')
            this.setSnackbar({
              show: true,
              text: 'LOGINSUCCESS_1',
              timeout: '1200'
            })
          }
        })
        .catch((err) => {
          // console.log('$api.auth.login err', err)
          this.setSnackbar({
            show: true,
            text: err.message ? err.message : 'LOGINERROR_1',
            timeout: '1200'
          })
        })
    },
    close() {
      this.ChangeDialog('')
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
